module.exports = __webpack_public_path__ + "static/media/login-bg.b463a2d3.jpg";